<script setup lang="ts">
import { tv, type VariantProps } from 'tailwind-variants/lite'
import { computed, type Component } from 'vue'
import type { AllowedTextElements } from '../types'

const style = tv({
  base: 'lui-text',
  variants: {
    variant: {
      'body-lg': 'lui-text--variant-body-lg',
      'body-md': 'lui-text--variant-body-md',
      'body-sm': 'lui-text--variant-body-sm',
      'body-xs': 'lui-text--variant-body-xs',
      'handwriting-md': 'lui-text--variant-handwriting-md',
      'smallcaps-md': 'lui-text--variant-smallcaps-md',
    },
  },
})

export interface TextProps {
  is?: AllowedTextElements | Component
  variant?: VariantProps<typeof style>['variant']
}

const props = withDefaults(defineProps<TextProps>(), {
  is: 'span',
  variant: 'body-md',
})

const classes = computed(() =>
  style({
    variant: props.variant,
  }),
)
</script>

<template>
  <component :is="is" :class="classes">
    <slot />
  </component>
</template>
